export enum ShopType {
  Regular = 0,
  Event = 1
}
